import React from 'react';
import { StarIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { Card, CardBody } from '../Card';
import { Avatar } from '../Avatar';
import { CtaButton } from '../CtaButton';
import { IMAGES } from '../../lib/content';
const CASES = [{
  name: 'Marisol R. · Atlanta, GA · Single arch · $20,000',
  person: 'Marisol R.',
  img: IMAGES.caseA,
  quote: 'I came to Pler after a year of searching and three cheaper quotes. What sold me was seeing my smile designed on my own face before I paid anything. Today, eight months later, I keep discovering in the mirror that the smile is mine, not from a catalog. Traveling from Atlanta was worth every dollar.'
}, {
  name: 'Robert T. · Nashville, TN · Full mouth package consultation, single arch scheduled',
  person: 'Robert T.',
  img: IMAGES.caseB,
  quote: 'What I feared most was the pain and being stuck with a removable denture for months. The sedation surgery was something else. On Day 5 I left with the final zirconia in place. The back and forth trips were over.'
}, {
  name: 'Diane K. · Charlotte, NC · Single arch · $20,000',
  person: 'Diane K.',
  img: IMAGES.caseC,
  quote: 'I bought one arch. I paid $20,000, which was $4,000 more than the $13K offer I saw in North Carolina. The difference is that my smile looks like mine. The other clinic showed me a generic catalog. I would pay those $4,000 again without thinking.'
}];
export function Testimonials() {
  return <section className="w-full bg-white py-20 lg:py-28" data-id="element-229" data-mp="26k2bh2qpk6w7">
      <div className="mx-auto max-w-6xl px-6" data-id="element-230" data-mp="26ihgxd4e8nyc">
        <SectionHeading title="What changes after Day 5." data-id="element-231" data-mp="22hntekuv5b5z">
          <p data-id="element-232" data-mp="1xjm8dudvn1rv">More confidence in photos, meals, conversations, and every moment you used to avoid.</p>
        </SectionHeading>
        <p className="mx-auto mt-5 max-w-3xl text-center text-sm italic leading-relaxed text-[#1A1A2E]/60" data-id="element-233" data-mp="r3trd7svs499">
          Each story below is a verified patient case on file at Pler Smile Dadeland. Names and minor identifying details are unmodified for these patients.
        </p>
        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3" data-id="element-234" data-mp="skpfmwzrnpl6">
          {CASES.map(c => <Card key={c.name} className="h-full" data-id="element-235" data-mp="el7ucrloiugk">
              <CardBody className="flex h-full flex-col" data-id="element-236" data-mp="ekeijc7v5erk">
                <div className="mb-4 flex items-center gap-3" data-id="element-237" data-mp="im037jqn2xcb">
                  <Avatar src={c.img} name={c.person} size="lg" data-id="element-238" data-mp="iodz1ut58dkx" />
                  <div className="text-sm font-semibold text-[#1A1A2E]" data-id="element-239" data-mp="4ucz4xqggkiz">{c.name}</div>
                </div>
                <div className="mb-3 flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-240" data-mp="9nfrj2jhxnxl">
                  {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} size={16} className="fill-teal text-teal" data-id="element-241" data-mp="3r0i6771q3mp2" data-mpi={i} />)}
                </div>
                <blockquote className="text-[15px] leading-relaxed text-[#1A1A2E]/80" data-id="element-242" data-mp="3vz36t7kw08e1">&ldquo;{c.quote}&rdquo;</blockquote>
              </CardBody>
            </Card>)}
        </div>
        <div className="mt-10 flex flex-col items-center" data-id="element-243" data-mp="3n2u6lqp355qu">
          <CtaButton label="Reserve My Free Consultation" data-id="element-244" data-mp="33g0rs25nw3vt" />
          <p className="mt-3 text-sm font-medium text-[#1A1A2E]/70" data-id="element-245" data-mp="2yfuyyinnobc5">You see your options before making any decision.</p>
        </div>
      </div>
    </section>;
}